import styled from 'styled-components';

export const ContentWrapper = styled.div`
  width: 308px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-bottom: 10px;
    width: 100%;
    height: auto;
  }
`;

export const HardLeftDiv = styled.div`
  align-self: center;
  margin-top: 35px;
  width: 95%;
`;

export const ClinicalStatusContainer = styled.div`
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.contrastText}88;

  ${(props) => props.theme.breakpoints.down('sm')} {
    justify-content: center;
    font-size: 14px;
    padding: 0;
  }
`;

export const ClinicalStatusDiv = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

export const SmallCircleClinical = styled.div`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.purple.main};
  margin-right: 10px;
`;

export const SmallCircleNonClinical = styled.div`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.purple.main};
  margin-right: 10px;
  margin-left: 10px;
`;
